<template>
  <div class="step">
      <div class="indicator">{{ indicator }}</div>
      <div class="description">
        {{ description }}
      </div>
  </div>
</template>

<script>
export default {
  props: {
    indicator: Number,
    description: String
  }
}
</script>

<style lang="scss">
.step {
    display: flex;
    align-items: center;
    padding: 8px 0;

    .indicator {
        background-color: #F6F6F6;
        font-size: 14px;
        font-weight: bold;
        text-align: center;
        color: #4B68EE;
        min-width: 32px;
        max-width: 32px;
        height: 32px;
        padding: 5px 0;
        border-radius: 100px;
    }

    .description {
        font-size: 14px;
        margin-left: 10px;
    }
}
</style>
